export const getLiquidationPrice = (
  usdc_amount: number,
  hedge_ratio: number,
  _duration: number,
  debt_value: number,
  entry_price: number,
  lower_tick_price: number,
  upper_tick_price: number,
  fee_income: number,
  market_price: number,
  extra_collateral: number
) => {
  const hodl_a_amount = (usdc_amount * (1 + hedge_ratio)) / 2 / entry_price;
  const Lx =
    (hodl_a_amount * (entry_price ** 0.5 * upper_tick_price ** 0.5)) /
    (upper_tick_price ** 0.5 - entry_price ** 0.5);
  const liquidation_price =
    (Lx * (upper_tick_price ** 0.5 - lower_tick_price ** 0.5) +
      fee_income +
      extra_collateral) /
    ((1.25 * debt_value) / market_price);

  return liquidation_price;
};
